import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { ViatgersService, type Viatger } from '@/services/viatgers'

interface UseViatgersParams {
    page: number
    searchTerm: string
    reservaId: string
    perPage?: number
}

interface ViatgersResponse {
    data: Viatger[]
    meta: {
        current_page: number
        per_page: number
        total: number
        total_pages: number
    }
}

export function useViatgers({
    page,
    searchTerm,
    reservaId,
    perPage = 20
}: UseViatgersParams) {
    return useQuery({
        queryKey: ['viatgers', { page, searchTerm, reservaId, perPage }],
        queryFn: async () => {
            const params = {
                page,
                search: searchTerm,
                reserva_id: reservaId === 'all' ? '' : reservaId,
                per_page: perPage,
            }
            const response = await ViatgersService.getAll(params)
            return response as ViatgersResponse
        },
        placeholderData: keepPreviousData,
        staleTime: 1000 * 60 * 1, // 1 minute
    })
}
